module.exports = "/_next/static/images/Connections-e791d934be134e259b9ecc2053e3d60e.webp";